/**
 * Custom JavaScript - Golden Vibe
 * Fichier pour les personnalisations JS du thème
 */

document.addEventListener('DOMContentLoaded', function() {

  /* ============================================
     Back in Stock Alert - masquer/afficher selon variante
     ============================================ */
  
  function updateBackInStockVisibility() {
    // Sélectionner TOUS les blocs contenant l'app Back in Stock
    var bisBlocks = document.querySelectorAll('.product-app-block');
    
    bisBlocks.forEach(function(block) {
      var bisButton = block.querySelector('.bis-product-button');
      
      // Si ce bloc contient l'app Back in Stock
      if (bisButton) {
        var restoreEmail = block.querySelector('#product-restore-email');
        
        if (!restoreEmail) {
          // Pas de #product-restore-email = toutes variantes en stock = masquer
          block.style.display = 'none';
        } else if (restoreEmail.style.display === 'none') {
          // #product-restore-email existe mais masqué = variante en stock = masquer
          block.style.display = 'none';
        } else {
          // #product-restore-email visible = variante en rupture = afficher
          block.style.display = 'block';
        }
      }
    });
  }
  
  // Masquer au démarrage tous les blocs Back in Stock
  var productAppBlocks = document.querySelectorAll('.product-app-block');
  productAppBlocks.forEach(function(block) {
    if (block.querySelector('.bis-product-button')) {
      block.style.display = 'none';
    }
  });
  
  // Vérifier après que l'app ait chargé
  setTimeout(updateBackInStockVisibility, 300);
  
  // Observer les changements sur chaque bloc
  productAppBlocks.forEach(function(block) {
    if (block.querySelector('.bis-product-button')) {
      var observer = new MutationObserver(function() {
        updateBackInStockVisibility();
      });
      
      observer.observe(block, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }
  });
  
  // Écouter les clics sur les variantes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.variant--item') || e.target.closest('.product--variants-list')) {
      setTimeout(updateBackInStockVisibility, 100);
      setTimeout(updateBackInStockVisibility, 300);
      setTimeout(updateBackInStockVisibility, 500);
      setTimeout(updateBackInStockVisibility, 800);
    }
  });

});